module.exports = __webpack_public_path__ + "img/電気回路_4_9_5.57967252.png";